import React from "react";
import { CopyOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import { theme } from "../../../../styles";
import { ShortLinkModal } from "./ShortLinkModal-styled";
import { ModalTextParagraph } from "../Modals-styled";


interface Props {
  shortLinkModalVisible:boolean,
  shortLink:string,
  setShortLinkModalVisibility:(value)=>void,
}

export default class extends React.Component<Props,{}> {
  constructor(props: Props) {
    super(props);
  };// /constructor()

  render = () => {
    const {
      shortLinkModalVisible,
      shortLink,
      setShortLinkModalVisibility
    } = this.props;

    return(
      <ShortLinkModal className="threed-configurator-checkout-modal"
        title="Share your ring!"
        visible={shortLinkModalVisible}
        footer={null}
        onCancel={() => { setShortLinkModalVisibility(false) }}
      >
        {shortLink && 
          <React.Fragment>
            <ModalTextParagraph>
              Your ring configuration has been saved and can be accessed at:
            </ModalTextParagraph>
              
            <ModalTextParagraph> 
              <a id={'short-link-link'} href={shortLink} target={"_blank"} rel={"noopener"}>{shortLink}</a>
              <CopyOutlined 
                type="copy"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  navigator.clipboard.writeText(shortLink);

                  const linkElement = document.querySelector('#short-link-link') as HTMLLinkElement;
                  linkElement.style.color = theme.colors.fallow;
                  window.setTimeout(() => {
                    linkElement.style.removeProperty('color');
                  }, 300)
                }}
              />
            </ModalTextParagraph>
          </React.Fragment>
        }

        {!shortLink &&
    	    <p>
            <Loading3QuartersOutlined
              type="loading-3-quarters"
              spin
            />
            Generating share link...
          </p>
        }
      </ShortLinkModal>
    )
  };// /render()

};// /class